import { queryFirst, queryAll, toggleClass } from '../../../../domUtil';
import { HIDDEN_CLASS } from '../../../../constants';

/**
 * Video controls helper function
 *
 * @param  { HTMLElement } parentElement parent elment of the component.
 */
export const videoControlsHelper = (parentElement) => {
    if (!parentElement) return;

    const videoEls = queryAll('.js-video-clickable', parentElement);
    const playButtonEl = queryFirst('.js-video-play', parentElement);
    const muteButtonEl = queryFirst('.js-video-mute', parentElement);

    if (!videoEls.length || !playButtonEl || !muteButtonEl) return;

    const pause = queryFirst('.video-pause', playButtonEl);
    const play = queryFirst('.video-play', playButtonEl);
    const mute = queryFirst('.video-mute', muteButtonEl);
    const unmute = queryFirst('.video-unmute', muteButtonEl);

    const toggleVideoPlayPause = () => {
        videoEls.forEach(videoEl => {
            videoEl.paused ? videoEl.play() : videoEl.pause();
        });
        toggleClass(play, HIDDEN_CLASS);
        toggleClass(pause, HIDDEN_CLASS);
    };

    const toggleVideoMuteUnmute = () => {
        videoEls.forEach(videoEl => {
            videoEl.muted = !videoEl.muted;
        });
        toggleClass(mute, HIDDEN_CLASS);
        toggleClass(unmute, HIDDEN_CLASS);
    };

    playButtonEl.addEventListener('click', toggleVideoPlayPause);
    muteButtonEl.addEventListener('click', toggleVideoMuteUnmute);
};

